export default {
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indietro"])}
}